import React from "react";
import { Select } from "@src/common/components";

export interface DriverSelectOption {
  label: string;
  value: string;
}

interface DriverSelectProps {
  options: DriverSelectOption[];
  value?: string;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  clearable?: boolean;
  isLoading?: boolean;
  size?: "mini" | "compact" | "default" | "large";
  error?: boolean;
}

function DriverSelect({
  options,
  value,
  onChange,
  placeholder = "Select driver",
  clearable = true,
  isLoading = false,
  size = "mini",
  error,
}: DriverSelectProps) {
  return (
    <Select
      size={size}
      options={options}
      clearable={clearable}
      placeholder={placeholder}
      isLoading={isLoading}
      error={error}
      value={value ? options.filter((option) => option.value === value) : []}
      onChange={(params) => {
        if (params.value.length === 0) {
          onChange(undefined);
        } else {
          onChange(params.value[0]?.value as string);
        }
      }}
      labelKey="label"
      valueKey="value"
    />
  );
}

export default DriverSelect;
